import config from "~/config";
import * as customError from '~/models/error';

export const useGeneralPagesStore = defineStore('generalPages', () => {

    const data = ref(null);

    async function getData() {


        const appendData = (list, item) => {
            list.push({
                languageId: item.LanguageId,
                text: item.Text,
            })
        }

        const url = `${config.API_BASE_URL}/api/Website/PublicData`;
        const { data: result } = await useFetch(url, {
            onResponse({ response }) {
                if (!response._data?.Data?.length) {
                    throw new customError.NoContent(response, url);
                }
            },
            transform(data) {
                const result = {
                    aboutwebsite: [],
                    privacy: [],
                    termsconditions: [],
                    contactus: [],
                    aboutquran: [],
                    related_ayah:[]
                }

                for (let item of data.Data) {

                    switch (item.Title) {
                        case 'about_quran_website':
                            appendData(result.aboutwebsite, item);
                            break;
                        case 'contact_us_content':
                            appendData(result.contactus, item);
                            break;
                        case 'privacy_content':
                            appendData(result.privacy, item);
                            break;
                        case 'terms_conditions_content':
                            appendData(result.termsconditions, item);
                            break;
                        case 'about_quran':
                            appendData(result.aboutquran, item);
                            break;
                        case 'related_ayah':{
                            appendData(result.related_ayah, item);
                            break;
                        }
                    }
                }
                return result;
            }
        });

        data.value = result.value;
    }

    return {
        data,
        getData,
    }

});